import withAemIntegration from "../../../withAemIntegration";

const CanonicalTermEditConfig = {
  emptyLabel: "Managed Answers Canonical Term",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const CanonicalTerm = (props) => {
  return (
    <div>
      <p>
        Term: <span>{props.term}</span>
      </p>
      <p>
        Tags: <span>{props.tags}</span>
      </p>
    </div>
  );
};

export default withAemIntegration(
  "lexus/components/managed-answer/canonical-term"
)(CanonicalTerm, CanonicalTermEditConfig);
